import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'; 
import {DirectionData} from '../models/directiondata';
import { environment } from '../../../../../environments/environment';
import { DirectionDetail } from '../models/directiondetail';

@Injectable({
  providedIn: 'root'
})
export class DirectionService{

  private URL = environment.apiUrl + 'XeOnline';

  constructor(
    private http: HttpClient
  ) { }

  getDirection(IMEI:string): Observable<DirectionData> {
    let para= new HttpParams().set("id",IMEI);
    return this.http.get<DirectionData>(this.URL,{params:para});
  }
  getDirectionDetails(bienso:string): Observable<DirectionDetail> {
    let para= new HttpParams().set("bienso",bienso);
    return this.http.get<DirectionDetail>(this.URL,{params:para});
  }
  GetOnlineDetails(check:string): Observable<DirectionData> {
    let para= new HttpParams().set("check",check);
    return this.http.get<DirectionData>(this.URL,{params:para});
  }

}